/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'AI incelemesi',
    AIReviewFailed: 'AI incelemesi başarısız oldu',
    AIReviewPassed: 'AI incelemesi geçti',
    AIReviewStatus: 'AI inceleme durumu',
    AIReviewing: 'AI incelemesi inceleniyor',
    America: {},
    CheckSupportInstall: 'Yeniden yükleme desteklenmeyi kontrol et',
    ImporterCommunityDisplayName: 'İthalatçı topluluğu görünen adı',
    ImporterContactEmail: 'İthalatçı iletişim e-postası',
    IndicatorLight: 'Gösterge ışığı',
    Instruction: 'Fark etme',
    MostPicture4OrVideo: '(Maks. 4 resim / 1 video)',
    PleaseContactPersonnelCommunicating: 'İletişim için lütfen CFMOTO personeli ile iletişime geçin.',
    USD: {},
    UnbindingApplicationCommitment: {},
    aboutAccount: 'Hesap Hakkında',
    aboutVehicle: 'Araç hakkında',
    accountApplyRejected: 'Hesap silme isteği reddedildi',
    accountCancel: 'Hesap silme isteği',
    accountDeletExplain: 'Hesap silme kılavuzu',
    accountDelete: 'Hesap silme',
    accountDeleted: 'Hesap silindi',
    accountFormatError: 'Yanlış hesap formatı/kullanıcı mevcut değil. Lütfen gerçek nedene göre ilgili metin yazarlığını eşleştirin',
    action: 'İşlem',
    actionFail: 'operasyon başarısız',
    actionSuccess: 'İşlem başarılı',
    activeScore: 'Aktif puanlama',
    activeTrigger: 'Kullanıcılar aktif olarak tetikler (APP Hakkında—Derecelendirmeye gidin)',
    activity: 'Etkinlik',
    activityCancel: 'Etkinlik iptali',
    activityCover: 'Etkinlik kapağı',
    activityDetails: 'Etkinlik detayı',
    activityId: 'Etkinlik Kimliği',
    activityList: 'Etkinlik listesi',
    activityManagement: 'Etkinlik yönetimi',
    activitySearch: 'Etkinlik arama',
    activityTime: 'Etkinlik zamanı',
    activityTitle: 'Etkinlik başlığı',
    activityVenue: 'Etkinlik mekanı',
    adaptable: 'годиться',
    add: 'Ekle',
    addAccountDeletExplain: 'Hesap Silme Bildirimi Ekle',
    addAuthenticationTime: 'Kimlik doğrulama zamanı ekle',
    addDataDeletExplain: 'Veri Silme Bildirimi Ekle',
    addEmail: 'Yeni E-posta',
    addExhibitionCategory: {},
    addExhibitionSeries: {},
    addInformationCategory: 'Yeni bilgi kategorisi ekle',
    addInformationContent: 'Yeni bilgi içeriği ekleyin',
    addKolUserAuthentication: 'KOL kullanıcısı kimlik doğrulaması ekle',
    addPicture: 'Resim Ekle',
    addPrivacyAgreement: 'Gizlilik sözleşmesi ekle',
    addPrivacySubmitSure: 'Yeni gizlilik politikasının yürürlük tarihi ve değişiklik açıklaması gönderildikten sonra değiştirilemez. Gönderimi onaylayın.',
    addPushConfiguration: 'İtme yapılandırması ekle',
    addQuestion: {},
    addSdkStaement: 'SDK Bildirimi Ekle',
    addServiceIntroduce: "Yeni Hizmetler'e giriş",
    addShowroomModel: 'Gösterim odası modellerini ekle',
    addThisUser: 'Bu kullanıcıyı ekle',
    addTopic: 'Bir konu ekle',
    addUser: 'Kullanıcı ekle',
    addUserAgreement: 'Kullanıcı Sözleşmesi Ekle',
    addUserRole: 'Kullanıcı Rolü Ekle',
    addVehicleModel: 'Yeni modeller',
    addVehicleModelCategory: 'Yeni araç kategorisi',
    addVideo: 'Video ekle',
    addedBy: 'Eklenen:',
    additionalFeedback: 'Ek Geri Bildirim',
    administratorUnbind: 'Yönetici bağlantısını kaldır',
    afternoon: 'Öğleden sonra',
    agreeSignOut: 'Sonlandırmayı kabul et',
    agreementContent: 'Anlaşma',
    all: 'Tümü',
    allArea: 'Hedef ülke/bölge',
    allComment: 'Tüm yorumlar',
    allImportSuccess: 'Alma tamamlandı. Hepsi başarıyla alındı',
    allUser: 'Tüm kullanıcılar',
    allVehicleModel: 'Tüm modeller',
    alreadyOver: 'hepsi burada',
    android: 'Android',
    answer: {},
    answerOta1: 'OTA, aracın hücresel ağ üzerinden buluttan en son ürün yazılımı yazılımını indirdiği ve sürüş deneyimini sürekli olarak optimize etmek için aracı CFMOTO RIDE aracılığıyla çevrimiçi olarak yükseltebileceğiniz anlamına gelir',
    answerOta2: 'TFT ekranın yeni sürümü yükseltilebildiğinde yükseltme bildirimi alırsınız. Mevcut sayfanın altında %s görüntüleniyorsa, araç tft ekranının yükseltilmesine gerek olmadığı anlamına gelir.',
    answerOta3: 'Daha fazla OTA işlem talimatını önceden öğrenmek için sağ üst köşedeki %s öğesine tıklayabilirsiniz',
    anyCar: 'Araba var mı?',
    appRating: 'Puanlama mekanizması yönetimi',
    appType: 'Telefon sistemi',
    appVersion: 'Uygulama sürümü',
    applicableCountry: {},
    applicableCountryName: {},
    applyTime: 'Başvuru süresi',
    applyUnbinding: 'Bağlama çözme uygulayın',
    appointmentReleaseTime: 'Randevu yayınlanma zamanı',
    approval: 'Onay',
    arrivalNumberDescription: 'Bildirim mesajı gönderildikten sonra cihaz terminaline gelenlerin gerçek sayısı (5 gün sonra gelenler sayılmayacaktır)',
    arrivalNumberVolume: 'Gelenlerin sayısı',
    askAllowUserSpeakInCommunity: 'Yasaklanan kullanıcının toplulukta paylaşım yapmasına izin vermek mi',
    askApproveIt: 'Onaylamak mı',
    askDeleteCategory: {},
    askDeleteInformactionCategory: 'Bu bilgi kategorisinin silinip silinmeyeceği',
    askDeleteInformationContent: 'Bilgi içeriğinin silinip silinmeyeceği',
    askDeleteKolUserAuthentication: 'Bu KOL kullanıcısı kimlik doğrulamasını silmek istediğinizden emin misiniz?',
    askDeleteQuestion: {},
    askDeleteThisActivity: 'Bu etkinliği silmek mi',
    askDeleteThisBanner: 'Bu afişi silmek mi',
    askDeleteThisComment: 'Bu yorumu silmek istediğinizden emin misiniz',
    askDeleteThisPost: 'Bu paylaşımı silmek mi',
    askDeleteThisTopic: 'Bu konuyu silmek mi',
    askDeleteVehicleType: 'Araç modelini silmeye emin misiniz',
    askDeleteVehicleTypeCategory: 'Bu model kategorisinin silinip silinmeyeceği',
    askDeleteVehicleTypeDetails: 'Araba modeli ayrıntılarının silinip silinmeyeceği',
    askDeleteVehicleTypeSeries: 'Bu model serisinin silinip silinmeyeceği',
    askLogout: 'Sistemden çıkmak istediğinizden emin misiniz?',
    askNotApproveIt: 'Onaylamamak mı',
    askSaveSettings: 'Ayarlar henüz kaydedilmedi, kaydetmek istiyor musunuz?',
    associatedPostNumber: 'İlişkili paylaşım sayısı',
    associatedPosts: 'İlişkili paylaşım',
    associatedVehicle: 'ilgili araç',
    assoclatedContent: 'İlişkili içerik',
    atmosphereCContent: 'Ayarlar henüz kaydedilmedi, kaydetmek istiyor musunuz?',
    atmosphereContent1Msg1: "İşlev açıldıktan sonra, cep telefonu Bluetooth 'u açar ve APP çalışmaya devam eder. Araca uzaktan yaklaşırken, aracın kilidi otomatik olarak açılabilir ve açılabilir.",
    atmosphereContent1Msg2: 'Normalde kilidi açılmamışsa ve açılmamışsa, kilidini açmak ve açmak için araç güç düğmesine basın',
    atmosphereContent1Msg3: 'Yakınlık otomatik kilit açma, bluetooth bağlantısı kesilmeden önce sadece bir kez tetiklenecektir',
    atmosphereContent2Msg1: 'İşlev açıldıktan sonra, aracın üç koşulu kapatıldıktan sonra araç 5 saniye sonra otomatik olarak kapanır, araç hızı 0 ve tapınak düştü',
    atmosphereContent2Msg2: 'Otomatik kapanma döneminde aracın çalıştırılması, aracın hızı 0 değil veya tapınak kaldırıldığında otomatik kapanma iptal edilir',
    atmosphereContent3Msg1: "İşlev açıldıktan sonra, araç kapatıldığında, cep telefonu Bluetooth 'u açar ve APP çalışmaya devam eder veya fiziksel anahtarı taşır. Araca uzaktan yaklaşırken, araç ışıkları konukları ağırlamak için yanıp sönecektir",
    atmosphereContent3Msg2: 'Sık tetikleyicilerin araç güç kaybına neden olmasını önlemek için, karşılama işlevi 30 saniye içinde iki kez tetiklendikten sonra, 30 dakika sonrasına kadar devam etmez',
    atmosphereContent4Msg1: 'Fonksiyon açıldıktan sonra, araç kapatıldıktan sonra uzak ve kısa farlar 10 saniye boyunca otomatik olarak yanacaktır.',
    atmosphereIntroduce1: 'Otomatik kilit açma talimatlarına yakın',
    atmosphereIntroduce2: 'otomatik kapanma talimatları',
    atmosphereIntroduce3: 'Otomatik uyandırma talimatları',
    atmosphereIntroduce4: 'Gecikmeli ışıklar kapalı',
    atmosphereSetINfo: 'Yeni ayarlar, araç çalıştırıldıktan sonra 1-3 dakika içinde geçerli olacaktır, lütfen aracın iyi bir sinyal konumunda olduğundan emin olun.',
    auditStatus: 'Onay durumu',
    authenticatedName: 'Kimliği doğrulanan ad',
    avatar: 'avatar',
    backApply: 'başvuruyu geri çekmek',
    backApplySuccess: 'başvurunun geri çekilmesi başarılı',
    backHome: 'Ana sayfaya geri dön',
    bannerDisplayImages: 'Banner resmi',
    bannerList: 'Afiş listesi',
    bannerManagement: 'Afiş yönetimi',
    bannerPictrure: 'Afiş çizimi',
    bannerSearch: 'Afiş arama',
    bannerTitle: 'Afiş başlığı',
    batchImport: 'Toplu İçe Aktarma',
    batchUser: 'Toplu kullanıcılar',
    beijingTime: 'UTC+8 saati',
    belogCategory: 'kategori',
    belongCategory: {},
    bindDevice: 'Bağlama cihazı',
    bindVehicle: 'Aracı bağla',
    bindingStatus: 'bağlama durumu',
    bindingText1: '1.\tTelematik Hizmetleri',
    bindingText10: '1.1.2.\tBir araç bulmak amacıyla araçlar arasındaki mesafenin hesaplanması ve yaya navigasyon dahil olmak üzere navigasyon sırasında rota planlamasının sağlanması .',
    bindingText11: "1.2.\tAracın durumuna göre Müşteri'ye gerekli bildirimlerin yapılması .",
    bindingText12: '1.2.1.\tCFMOTO, araç bakımıyla ilgili Müşteri bildirimlerini sonlandıracaktır (örneğin, Müşterinin kullandığı toplam mesafeye, Müşterinin aracı satın aldığı zamana, araç bakımı için süre veya sürüş mesafesi gerekliliklerine göre) .',
    bindingText13: '1.2.2.\tAraç verilerine bağlı olarak , CFMOTO Müşteriye anormal durum bildirimleri gönderecektir ; müşteri hizmetleri sağlamak ve aracın takip optimizasyonunu sağlamak için (modele bağlı olarak) OEM tarafından veri analizi dahil .',
    bindingText14: '1.3.\tAraçla ilgili ciddi bir kaza bildirmesi durumunda kazanın nedeninin analiz edilmesinde destek .',
    bindingText15:
      "1.3.1.\tsırasında Aracın devrilmesi veya yan yatması gibi ciddi bir Araç kazası durumunda CFMOTO, kazanın Araçtaki bir kusurdan mı yoksa başka koşullardan mı kaynaklandığının açıklığa kavuşturulmasında talep üzerine Müşteriye destek olacaktır. Talep, Müşteri tarafından Araç Satış Sözleşmesinde belirtilen yerel distribütör / satış ortağı aracılığıyla CFMOTO'ya iletilecektir.",
    bindingText16: '1.3.2.\tMevcut veriler buna izin verdiği ölçüde, CFMOTO, kazanın nedeni ile ilgili verileri değerlendirecek ve Müşteriye ilgili bir rapor sağlayacaktır.',
    bindingText17: '1.4.\tAraç kaybolduktan sonra Müşterinin Aracı kurtarması için yardım .',
    bindingText18: '1.4.1.\tAraç kaybolursa, CFMOTO talep üzerine ve varsa, Müşteriye Aracın konum verilerini ve Aracın diğer yararlı durum verilerini (son etkinleştirme konumu, mevcut araç durumu vb.) sağlayacaktır.',
    bindingText19: "1.4.2.\tTalep, Müşteri tarafından Araç Satış Sözleşmesinde belirtilen yerel distribütör / satış ortağı aracılığıyla CFMOTO'ya iletilecektir.",
    bindingText2:
      'CFMOTO Powersports, Inc. (bundan sonra “ CFMOTO ” olarak anılacaktır ), CFMOTO aracını satın alan müşteriye (bundan böyle “Müşteri” olarak anılacaktır ) araç telematik hizmetleri sunmaktadır . Bu hizmetler için CFMOTO, Araç ve ilgili zaman dilimindeki sürüş davranışı hakkında Araç tarafından kaydedilen verileri kullanır. Ayrıntılı olarak, bu aşağıdaki verilerle ilgilidir:',
    bindingText20: '1.5.\tSatış sonrası sorunların raporlanması .',
    bindingText21: '1.5.1.\tCFMOTO, Aracın aksamlarının arızalanması durumunda Araç tarafından gönderilen hata kodu bildirimlerini uzaktan toplar ve ilgili bilgileri Müşterinin talebi üzerine doğrudan Müşteriye sunar.',
    bindingText22: "1.5.2.\tTalep, Müşteri tarafından Araç Satış Sözleşmesinde belirtilen yerel distribütör / satış ortağı aracılığıyla CFMOTO'ya iletilecektir.",
    bindingText23: '2.\tHizmetin Kısıtlamaları ve İstisnaları',
    bindingText24: '2.1.\tHizmetler araç verilerinin doğru sağlanmasına bağlı olduğundan, Araçta yapısal veya diğer teknik değişikliklerin hizmetlerin sağlanmasını sınırlayabileceği veya hatta imkansız hale getirebileceği açıkça belirtilir.',
    bindingText25: "2.2.\t3. şahıs verilerinin veya telekomünikasyon ağlarının performansı nedeniyle bu tür hizmetlerin sağlanamadığı durumlarda , CFMOTO'nun herhangi bir sorumluluğu hariçtir.",
    bindingText26: '3.\tMahremiyet',
    bindingText27:
      "CFMOTO aracıyla bağlantılı olarak işlerken geçerli veri koruma düzenlemelerine uyacaktır . C FMOTO'nun gizlilik politikasının şartları, bu CFMOTO RIDE UYGULAMASINDA belirtilmektedir . Gizlilik politikasına ek olarak , bu bildirim gizlilik politikasına uygundur . Ayrıca Müşteri , bu bildirimin kapsamına girmeyen veri işlemeyle ilgili bazı içerikler için gizlilik politikasına başvurabilir .",
    bindingText28: '4.\tMüşteri servisi',
    bindingText29:
      "4.1.\t, gizlilikle ilgili sorularını, yorumlarını veya endişelerini CFMOTORIDEAPP@cfmotousa.com adresine göndermekten çekinmeyebilir veya CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447 adresine yazabilir . (888) 823-6686'da CFMOTO Müşteri İlişkileri. ",
    bindingText3: 'Kullanıcı Sürüş Davranışı Verileri : hızlanma, yavaşlama, hız, viraj, son sürüş süresi ve son sürüş mesafesi dahil .',
    bindingText30: '5.\trevizyonlar _',
    bindingText31: "5.1.\tCFMOTO RIDE'da yayınlayacağız. Uygulama ve/veya uygun şekilde bunu yapmadan önce bildirimde bulunun.",
    bindingText4:
      'Araç Durumu Verileri: \tSürüş modu, kalan yakıt, anlık yakıt ekonomisi, kilometre, aracın gerçek zamanlı vitesi, motor hızı, lastik basıncı, lastik sıcaklığı, akü aktivasyon voltajı verileri dahil olmak üzere Aracın gerçek zamanlı durumunu ifade eder. , soğutma sıvısı sıcaklığı, elektronik kilit durumu, akıllı cihaz yazılım sürümü, akıllı cihazların sinyal gücü, ön panelin mevcut ayarı.',
    bindingText5:
      ' Araç Alarm Verileri: \tmotor sıcaklığı, aşırı hız, aşırı sürüş süresi, yüksek soğutma sıvısı sıcaklığı, anormal araç hareketi, anormal lastik basıncı, titreşim, boşaltma, çarpışma vb . gibi belirli veriler önceden ayarlanmış bir değeri aşarsa gönderilecek alarm verileri .',
    bindingText6: ' Araç Arıza Bilgileri: \tAracın her bir dahili parçası tarafından bildirilen arıza kodlarını ifade eder .',
    bindingText7: 'Araç Konum Verileri: Aracın belirli coğrafi konumunu ifade eder.',
    bindingText8: '1.1.\tsağlama _ CFMOTO RIDE APP aracılığıyla araçla ilgili hizmetlerle Müşteri .',
    bindingText9: '1.1.1.\tAPP aracılığıyla araçları uzaktan yönetebilir (aracın konumunu görüntüleme, araç bilgilerini ve işlevlerini ayarlama, araç durumunun uzaktan kumandası vb. dahil).',
    bindingUser: 'Bağlayıcı kullanıcı',
    bound: 'Bağlı',
    businessType: 'İşletme türü',
    button: 'Düğme',
    callbackedApply: 'Hesap silme başvurunuzu yyyy-MM-dd HH:mm:ss tarihinde geri çektiniz',
    callbackedApplySyncTip:
      'yyyy-MM-dd HH:mm:ss Hesap silme isteğiniz gönderildi.  İsteği aldıktan 15 gün sonra hesabınızı ve ilgili verilerinizi kalıcı olarak sileceğiz.  Silme işleminden sonra artık CFMOTO RIDESYNC hizmetini kullanamayacaksınız.  Hesap silme işleminizi iptal etmek için lütfen web sayfasını tekrar ziyaret edin veya hesap silme isteğini geri çekmek için 15 gün içinde uygulamaya giriş yapın.',
    callbackedApplyTip:
      'yyyy-MM-dd HH:mm:ss Hesap silme isteğiniz gönderildi.  İsteği aldıktan 15 gün sonra hesabınızı ve ilgili verilerinizi kalıcı olarak sileceğiz.  Silme işleminden sonra artık CFMOTO RIDE hizmetini kullanamayacaksınız.  Hesap silme işleminizi iptal etmek için lütfen web sayfasını tekrar ziyaret edin veya hesap silme isteğini geri çekmek için 15 gün içinde uygulamaya giriş yapın.',
    cancel: 'İptal etmek',
    cancellationAgreement: 'İptal sözleşmesi',
    cancelled: 'İptal edildi',
    carOwner: 'Mal sahibi',
    carUserScore: 'Araç sahibi derecelendirmeleri',
    cardPass: 'Başarılı kimlik doğrulaması!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Doğrulama kodu doğrulamasına değiştir',
    changeDescriptionType: 'Açıklamayı Değiştir',
    changeDescriptionTypeSelectNo: 'Kişisel bilgi işleme mevzuatında değişiklik içermez',
    changeDescriptionTypeSelectYes: 'Kişisel bilgilerin işlenmesine ilişkin mevzuat değişiklikleri',
    changeEmailInfo: 'E-postaya geç',
    changeFail: 'Durum değişikliği başarısız oldu',
    changeOne: 'Değiştirmek',
    changePassValidate: 'Şifre doğrulamasına değiştir',
    changePasswordFailed: 'Parola değişikliği başarısız oldu',
    changePasswordSuccessful: 'Şifre değişikliği başarılı',
    changePhoneInfo: 'Telefon numarasına geç',
    changeStore: 'Mağazayı değiştir',
    changeSuccess: 'Durum başarıyla değiştirildi',
    channelType: 'geri bildirim kanalı',
    characterLimitExceeded: 'Karakter sınırı aşıldı',
    checkConfigurationTwo: '%s Çince ya da İngilizce tamamen ayarlanmadı, lütfen kontrol edin',
    checkCopyWriting: 'Çince veya İngilizce içerik doldurulmamış, lütfen kontrol edin',
    checkEmpty: '%s boş, lütfen kontrol edin',
    checkTriggerType: 'Doldurulmamış bir tetik mekanizması koşulu var, lütfen kontrol edin',
    checkUpdate: 'Güncellemeleri kontrol et',
    cityFilter: 'Şehir filtresi',
    clickImmediateFeedback: 'Şimdi geri bildirimde bulunmak için tıklayın',
    clickNumber: 'Tıklama sayısı',
    clickNumberDescription: 'Bildirim mesajı başarıyla görüntülendikten sonra kullanıcıların gerçek tıklama sayısı (5 gün sonra yapılan tıklamalar sayılmayacaktır)',
    clickNumberVolume: 'Tıklama sayısı',
    clickToFeedback: 'Geri bildirim için tıklayın',
    clicks: 'Tıklama',
    closeNum: 'kapanış',
    closeTask: 'Görev iptal edildi',
    code: 'doğrulama kodu',
    colorPicture: 'Renk blok resim',
    comment: 'Yorum',
    commentContent: 'Yorumlar',
    commentList: 'Yorum listesi',
    commentNumber: 'Yorum sayısı',
    commentTime: 'Yorum zamanı',
    communication: 'iletişimde',
    community: 'Topluluk',
    communityManagement: 'Topluluk yönetimi',
    communityRule: 'Topluluk kuralları',
    completePuzzle: 'Lütfen bulmacayı tamamlayın',
    completed: 'Tamamlandı',
    condition: 'durum',
    configureLanguage: 'Dili yapılandır',
    configurePicture: 'Resmi yapılandır',
    confirm: 'Teyit etmek',
    confirmDeletePictures: 'Bu resmi silmeyi onaylayın',
    confirmReviewNoPass: 'İncelemede başarısız olmak için onaylayın',
    confirmReviewPass: 'İncelemeyi geçmek için onaylayın',
    consultDealer: 'Lütfen yerel satıcınıza danışın',
    contact: 'Hesap silme başvurunuz reddedildi. Herhangi bir sorunuz varsa, danışmak için lütfen it@cfmoto.com ile iletişime geçin.',
    contactMail: 'E-posta adresi',
    contactMethod: 'İletişim',
    contactUs: 'Bize ulaşın',
    content: 'İçerik',
    contentType: 'İçerik türü',
    copyFail: 'Kopyalama başarısız oldu',
    copyLink: 'Bağlantıyı kopyala',
    copySuccess: 'Başarıyla kopyalandı',
    copyWriting: 'Açılır içerik',
    country: 'Ülke/Bölge',
    countryCode: 'Ülke kodu',
    countryName: 'Ülke',
    countryNumber: 'Ülke kodu',
    countryRegion: 'Ülke / Bölge',
    create: 'Yeni ek',
    createBy: 'Kurucu',
    createStore: 'Mağaza oluştur',
    createTime: 'yaratma zamanı',
    cs_CZ: 'Çek',
    currency: {},
    currentConfig: {},
    currentCountryStoreTotal: 'Mevcut ülkedeki toplam mağaza sayısı',
    currentTime: 'Geçerli saat',
    customPage: 'Özel sayfa',
    customSettings: 'Özel Sütunlar',
    dataDeletExplain: 'Veri silme kılavuzu',
    dataDelete: 'Veri silme',
    dataDeleteApply: 'Veri silme isteği',
    dataFormatError: 'Veri biçimi hatası',
    dataPermissionScope: 'Veri izni kapsamı',
    dataType: 'Veri türü',
    dayOne: 'günler bir kez',
    days: 'gün',
    daysAgo: '%s gün önce',
    de_DE: 'Almanca',
    dealDate: 'İşlem süresi',
    dealerOperationList: 'Bayi işlem listesi',
    dealerOperationQuery: 'Bayi işlem sorgusu',
    dealerOperationRecord: 'Satıcı işlem kaydı',
    dealerStore: 'Satıcı mağazaları',
    dealerStoreImportTempateName: 'Bayi mağaza içe aktarma şablonu',
    dealerStoreQuery: 'Satıcı mağazaları sorgusu',
    dealers: 'İthalatçı',
    default: 'Varsayılan',
    defaultMap: 'Varsayılan harita',
    delete: 'Sil',
    deleteAccountSYNCStep: 'CFMOTO RIDESYNC hesabınızın silinmesini istemek için şu adımları takip edebilirsiniz',
    deleteAccountStep: 'CFMOTO RIDE hesabınızın silinmesini istemek için şu adımları takip edebilirsiniz',
    deleteDataSYNCStep: 'CFMOTO RIDESYNC verilerinizin silinmesini istemek için şu adımları takip edebilirsiniz',
    deleteDataStep: 'CFMOTO RIDE verilerinizin silinmesini istemek için şu adımları takip edebilirsiniz',
    deleteFail: 'Silme başarısız oldu',
    deleteFinish: 'Silme işlemi tamamlandı',
    deleteKolUserAuthentication: 'KOL kullanıcısı kimlik doğrulamasını sil',
    deleteStore: 'Mağazayı sil',
    deleteSuccess: 'Silme başarılı',
    deleteTip: 'Bu gönderiyi silmek istediğinizden emin misiniz? Silinen bilgiler kurtarılamaz',
    deleteVersionWarn: 'Bu sürüm kaydının silinip silinmeyeceği',
    deleteVideo: 'Bu video silinsin mi?',
    detailAddress: 'Detaylı Adres',
    details: 'Detaylar',
    determine: 'Emin',
    deviceCodeGet: 'Cihaz kodunu alın:',
    deviceContent:
      'Elektronik çit alıcısı (anahtar olarak anılır) ekipman kodu, 10 haneli kodlardan oluşan bir dizidir. Ekipman kodu, QR kodu ve CE işareti, gümüş renkli PVC kendinden yapışkanlı etiketin üzerine basılmıştır. Toplamda üç etiket vardır, biri araç gövdesine yapıştırılmıştır (görüntülemek için koltuk minderini kaldırmanız gerekir); diğer ikisi aracın aksesuar çantasına yerleştirilir. (Kullanıcıların etiketi araç kılavuzuna veya uzaktan kumandaya yapıştırması tavsiye edilir)\nAnahtarı açmak için lütfen ON tuşunu basılı tutun ve anahtarın arkasındaki QR kodunu tarama çerçevesine yerleştirin',
    deviceNo: 'İlişkili cihaz numarası',
    deviceNumber: 'Cihaz numarası',
    deviceTitle: 'Kod Kontrol',
    digitalKey: 'dijital anahtar',
    digitalKeyDesc: 'Fiziksel bir anahtar taşımanıza gerek yok, APP Bluetooth ile bağlandıktan sonra aracın kilidini açmayı destekleyin (bazı modellerde desteklenir)',
    directRelease: 'Doğrudan yayınla',
    disagree: 'Katılmıyorum',
    displayNumberDescription: 'Bildirim mesajı geldikten sonra cihaz terminalindeki gerçek başarılı ekran sayısı (5 gün sonraki ekranlar sayılmayacaktır)',
    displayNumberVolume: 'Ekran sayısı',
    displayOrder: {},
    displayPicture: {},
    donwloadTemplateDescription: {},
    download: 'İndir',
    downloadFailFile: 'Başarısız dosyayı indir',
    downloadSuccessful: 'İndirme başarılı',
    downloadTemplate: 'Şablonu indir',
    downloading: 'İndiriliyor...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'düzenlemek',
    editAccountDeletExplain: 'Hesap Silme Bildirimini Düzenle',
    editActivity: 'Etkinliği düzenle',
    editAppRating: 'Derecelendirme mekanizmasını düzenleyin',
    editBanner: 'Afişi Düzenle',
    editDataDeletExplain: 'Veri Silme Bildirimini Düzenle',
    editExhibitionCategory: {},
    editExhibitionSeries: {},
    editFunctionIntro: {},
    editInformation: 'Bilgileri düzenle',
    editInformationCategory: 'Bilgi kategorisini düzenle',
    editInformationContent: 'Bilgi içeriğini düzenle',
    editKolUserAuthentication: 'KOL kullanıcısı kimlik doğrulamasını düzenle',
    editModelSeries: 'Model serisini düzenle',
    editPicture: 'Resmi düzenle',
    editPushConfiguration: 'İtme yapılandırmasını düzenle',
    editRemark: 'Notları düzenle',
    editServiceIntroduce: {},
    editShowroomModel: 'Gösterim odası modellerini düzenle',
    editSuccess: 'Başarıyla düzenlendi',
    editTime: 'Düzenleme zamanı',
    editUnbindingCommitment: {},
    editUser: 'kullanıcıyı düzenle',
    editVehicleModel: 'Modeli düzenle',
    editVehicleModelCategory: 'Araç kategorisini düzenle',
    effecting: 'Etkinleştirme bekleniyor',
    effectiveTime: 'Yürürlük Tarihi',
    electricVehicle: 'Elektrikli araç',
    email: 'E-mail',
    emailAdress: 'E-posta adresi',
    emailAdressTip: 'Not:  Bu e-posta adresi, müşteriyle e-posta yoluyla iletişim kurmak için kullanılır.  Lütfen e-posta adresinin doğru olduğundan emin olun',
    emailContent: 'E-postanın içeriği',
    emailImportTemplate: 'E-posta adresini içe aktarma şablonu',
    emailImportTemplateToDownLoad: 'E-posta adresleri toplu olarak içe aktarılabilir; indirmek için tıklayın',
    emailList: 'E-posta listesi',
    emailManage: 'E-posta Yönetimi',
    emailMass: 'E-posta Patlaması',
    emailSearch: 'E-posta sorgusu',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'E-posta',
    emailTitle: 'Ders',
    en_US: 'İngilizce',
    enableStatus: 'Etkin durum',
    enabled: 'olanak vermek',
    endTime: 'Bitiş zamanı',
    endTimeLargeStartTime: 'Bitiş saati başlangıç saatinden sonra olmalıdır',
    enterAnswer: {},
    enterCategory: {},
    enterCodeToSafeAccount: 'Hesabınızın güvenliğini sağlamak için lütfen silmek hesap istediğiniz hesabın bilgilerinizi onaylayın, ve kimliğinizi doğrulamak için şifrenizi veya bir doğrulama kodunu girin.',
    enterCodeToSafeData: 'Verilerinizin güvenliğini sağlamak için lütfen hesap bilgilerinizi onaylayın, ve kimliğinizi doğrulamak için şifrenizi veya bir doğrulama kodunu girin.',
    enterIntroduceText: {},
    enterLink: {},
    enterPopupTitle: {},
    enterQueryConditionLookData: 'Sorgu koşullarını girdikten sonra verileri görüntüleyebilirsiniz.',
    enterQuestion: {},
    enterQuestionAndAnswer: {},
    enterSureUrl: {},
    enterTypeOfLanguage: {},
    enterUnbindingCommitment: {},
    entrance: {},
    errorLatAndLon: 'Enlem ve boylam yanlış biçimlendirilmiş, lütfen kontrol edin',
    errorLocation: {},
    es_ES: 'İspanyol',
    estimatedTime: 'Tahmini süresi',
    everySet: 'Ayar başına',
    examineResultMessage: 'Başvuru materyallerini mümkün olan en kısa sürede doğrulayacağız, lütfen bildirim çubuğuna veya APP mesaj merkezine zamanında dikkat edin.',
    example: 'emsal',
    exhibition: {},
    exhibitionCategory: {},
    exhibitionCategoryList: {},
    exhibitionCategorySearch: {},
    exhibitionSeries: {},
    exhibitionSeriesList: {},
    exhibitionSeriesSearch: {},
    exportContent: 'İçeriği dışa aktar',
    exportExcel: "EXCEL'e Aktar",
    exportLengthExceedOfMonth: 'İhracat süresi %s ayı geçmemelidir',
    externalLink: 'Dış bağlantı',
    failed: 'Başarısız oldu',
    failedToPreview: 'İnceleme başarısız oldu',
    feedBackResut: 'Geri bildirim sonuçları',
    feedBackTime: 'Geri bildirim zamanı',
    feedBackVechle: 'Araç',
    feedbackAppQuestion: 'Sorunun hızlı bir şekilde bulunmasına ve giderilmesine yardımcı olmak için lütfen oluşma zamanını, APP sürümünü, cep telefonu modelini, çalışma yolunu ve sorun açıklamasını ayrıntılı olarak açıklayın!',
    feedbackDetails: 'Geri bildirim detayları',
    feedbackGuideDesc: 'Daha fazla bilgi için lütfen aşağıdaki geri bildirim kanalı aracılığıyla bizimle iletişime geçin.',
    feedbackLabelFileList: 'Lütfen bir resim',
    feedbackMapQuestion: {},
    feedbackMessageSubmitError: 'Feedback başarısız oldu',
    feedbackOtherQuestion: 'Lütfen ne zaman olduğunu, nasıl olduğunu ve sorunu açıklayın',
    feedbackReceived: 'Geri bildirim alındı',
    feedbackRecord: 'Geri bildirim kaydı',
    feedbackRulesFileListMaxSize: 'Yüklenen dosya çok büyükdür',
    feedbackRulesFileListOverType: 'Desteklenmeyen format ı',
    feedbackSubmitTip: 'Herhangi bir sorunuz veya yorumunuz varsa CFMOTO Meksika Müşteri Hizmetleri Merkeziyle doğrudan WhatsApp (+52 18115286003) veya e-posta (servicioalclient@cfmoto.com.mx) aracılığıyla iletişime geçebilirsiniz.',
    feedbackSuggest: 'Değerli önerilerde bulunmaya hoş geldiniz, fikirlerinizi ciddiyetle değerlendireceğiz',
    feedbackSupplement: 'Lütfen sorunun açıklamasını ekleyin',
    feedbackText: 'Geri bildirim',
    feedbackType: 'Geri bildirim türü (tek seçenek)',
    feedbackVehicleQuestion: 'Lütfen ne zaman olduğunu, nasıl olduğunu ve sorunu açıklayın',
    female: 'Bayan',
    fileCountExceed: 'Dosyaların sayısı sınırı aşıyor',
    fileSizeExceed: 'Dosya boyutu sınırı aşıyor',
    fileUploadingPleaceWait: 'Dosya yükleniyor, lütfen bekleyin',
    finalOperator: {},
    firstMenu: 'First level menu',
    forcedUpgrade: 'Zorunlu güncelleme',
    forgetPassword: 'Şifreyi unut',
    fourCarOfNumber: 'Dört tekerlekli araç olan kullanıcı sayısı',
    fourWheel: 'Dört tekerlekli motosikletler',
    fourWheelConfig: {},
    fourWheeler: 'Dört tekerlekli',
    fourWheelerMostClicks: 'En çok tıklanan dört tekerlekli araç modelleri',
    fourWheelowner: {},
    fr_FR: 'Fransızca',
    frankfurt: 'Frankfurt',
    friday: 'Cuma',
    fuctionIntro: {},
    fullscreen: 'Tam ekran',
    funServiceIntro: {},
    function: 'İşlev',
    functionConfiguration: {},
    functionConfigureTip: 'Bu işlev yalnızca ithalatçının veya ülkedeki/bölgedeki kullanıcıların adı altında yapılandırılmış araçlar için geçerlidir',
    functionDescription: {},
    functionDetail: {},
    functionIntroduce: 'İşlev Açıklama',
    functionSetting: {},
    functionalOverview: 'İşlevlere Genel Bakış',
    galleryEntrance: 'Galeri girişi',
    galleryEntranceUploadRules: 'Format gereksinimleri: jpg/jpeg/png, önerilen oran 4:3, boyut en fazla 5 MB',
    gender: 'Cinsiyet',
    generalAlarm: 'General alarm',
    geofence: 'elektronik çit',
    getCarPosition: 'Araç konumunu zamanında alın',
    getCode: 'Göndermek',
    goCustomPage: 'Özel sayfaya git',
    goOffline: 'Çevrimdışı',
    goOnline: 'Çevrimiçi',
    goUrlLink: 'URL bağlantısına git',
    groupTrail: {},
    groupTrailConfig: {},
    guest: 'Araba yok',
    haveTwo: 'Her ikisi de',
    havedWrite: 'Dolduruldu',
    havedWriteAll: 'içindeki tüm içeriğin doldurulduğundan emin olun',
    havedWriteAllOrEmpty: 'içindeki her şeyin dolu veya boş olduğundan emin olun',
    helpAndFeedback: 'Yardım ve geri bildirim',
    helpCenter: 'Yardım Merkezi',
    helpMessageHistoryDelete: 'Tüm arama kayıtları silinsin mi?',
    helpful: {},
    hint: 'İpucu',
    historyDelete: 'Tüm arama kayıtları silinsin mi?',
    home: 'Ana sayfa',
    homePage: 'Kişisel Ana Sayfa',
    hour: 'Saat',
    hoursAgo: '%s saat önce',
    iWantEnableStoreUserQuery: 'Mağaza kullanıcı sorgusunu açmak istiyorum',
    iWantToPostStatistics: 'İstatistik yayınlamak istiyorum',
    identification: 'Tanılama',
    identificationText: 'Kimlik',
    imageSizeExceed: 'Lütfen %s genişliği ve yüksekliği olan bir resim yükleyin',
    imageUploadFailed: 'Resim yüklenemedi',
    immediateSend: 'Şimdi gönder',
    imporFailedOfTableHeader: 'Alma başarısız oldu. Dosya başlığı eşleşmedi',
    import: 'içe aktarmak',
    importDetails: 'Soru detayları',
    importExcel: "EXCEL'i içe aktar",
    importFail: 'İçe aktarma başarısız oldu',
    importStatus: 'İçe aktarma durumu',
    importSuccessful: 'İçe aktarma başarılı',
    importTemplate: 'Şablon indirmeyi içe aktar',
    importer: 'ithalatçı',
    importerAccountOperationRecord: 'İthalatçı hesap işlemi ve giriş kaydı',
    importerAvatar: 'İthalatçı avatarı',
    importerDisplayName: 'İthalatçı görünen adı',
    importerEnquiry: 'İthalatçı sorgusu',
    importing: 'İçeri aktarılıyor...',
    inProcess: 'karşı önlemler',
    inProgress: 'devam etmekte',
    individualCenter: 'Bireysel merkez',
    informationCategory: 'Bilgi kategorisi',
    informationCategoryList: 'Bilgi kategorilerinin listesi',
    informationCategoryQuery: 'Bilgi kategorisi sorgusu',
    informationContent: 'Bilgi içeriği',
    informationContentList: 'Bilgi içerik listesi',
    informationCotnentQuery: 'Bilgi içeriği sorgusu',
    informationCover: 'Bilgi Kapağı',
    informationDetails: 'nformation Details',
    informationImage: 'Kapak resmi',
    informationManagement: 'Bilgi Yönetimi',
    informationTitle: 'Bilgi başlığı',
    informer: 'Bilgilendirici',
    informerId: 'Bilgilendirici ID',
    initialPassword: 'İlk şifre',
    inputAgreementContent: 'Lütfen sözleşmenin içeriğini girin',
    inputErrorEmoji: 'Lütfen ifade girmeyin',
    installDeviceYouCan: 'Bu cihazı kurmak şunları yapmanızı sağlar',
    installVehicleModelAdd: 'Yeniden iletilmiş araç modelinin Tasvir Ekle',
    installVehicleModelDescription: 'Description of the retrofitted model',
    installVehicleModelEdit: 'Yeniden yüklenen araç modelinin Tasvir Düzenle',
    instrumentLastedVersion: 'Tft ekranı zaten en son sürüm',
    instrumentupgrade: 'TFT ekran yükseltmesi',
    intelligentInternetServiceIntroduction: 'Hizmet tanıtımı',
    introText: {},
    introduction: 'Giriiş',
    invalidVercode: 'Geçersiz doğrulama kodu',
    iovNotice1: 'Yukarıdaki işlevler araç ağ cihazına (T-Box) dayanmaktadır, lütfen satın almak ve yüklemek için yerel satıcıya danışın.',
    iovNotice2: 'Yukarıdaki işlevler, her modelin konfigürasyonuna ve bulunduğu bölgeye göre farklıdır. Ayrıntılar için lütfen yerel bayiye danışın.',
    iovNotice3: 'Lütfen cihazı bağlarken gerekli olan cihaz numarasını önceden kaydedin ve kaydedin. Bağlama ve kurulumu tamamladıktan sonra daha fazla işlevi deneyimleyebilirsiniz.',
    isHelpful: 'Yardımcı olur mu?',
    isStop: {},
    isSupportedChildOwnerOffMapDown: {},
    isSupportedNoOwnerOffMapDown: {},
    isSupportedOffMapDown: {},
    it_IT: 'İtalyan',
    iterativeVehicleFunctions: 'Aracın ana parçaları, araç işlevlerini sürekli olarak yinelemek için uzaktan çevrimiçi olarak yükseltilebilir',
    jumpSettings: 'Atlama ayarları',
    jumpTarget: {},
    jumpToWeb: {},
    jumpUrl: {},
    justNow: 'Hemen şimdi',
    kolUserList: 'KOL kullanıcıları listesi',
    kolUserManagement: 'KOL kullanıcısı yönetimi',
    kolUserQuery: 'KOL kullanıcısı sorgusu',
    language: 'Dil',
    language1: 'İlişkili dil',
    languages: 'dilim',
    lastLoginTime: 'Son giriş zamanı',
    lastModifiedBy: 'Son değişiklik',
    lastUpdateTime: 'Son güncellenme zamanı',
    latitude: 'Enlem',
    launchActivity: 'Etkinlik başlat',
    likeNumber: 'Beğeni sayısı',
    linkAddress: {},
    linkUrlDescription: {},
    listDisplayImages: 'Liste ekranı',
    listOfImporters: 'İthalatçılar listesi',
    listOfQuestion: {},
    listShowStoreCoverPic: 'Liste mağaza kapak resmini göster',
    loadSuccess: 'Yükleme tamamlandı',
    loading: 'Yükleniyor',
    locationFail: {},
    log: 'Günlük',
    login: 'Giriş yapmak',
    loginCountry: 'Oturum aç ülke/bölge',
    logout: 'Çıkış Yap',
    longitude: 'Boylam',
    loosing: 'Verileri yeniliyorum...',
    lowCompatibleVersion: 'Minimum uyumlu sürüm',
    mail: 'E-posta',
    male: 'Erkek',
    manualReviewStatus: 'Manuel inceleme durumu',
    mapManage: {},
    marketDataOfdealerStores: 'Satıcı mağazaları pazar verileri',
    masteringCyclingData: 'Ana sürüş verileri',
    maximum: 'Maks.',
    maximumBannerCountTip: 'Aynı anda en fazla %s banner çevrimiçi olabilir.  Lütfen önce en az birini çıkarın.',
    maximumValue: 'Maksimum',
    menuFunctionName: 'Menü işlevi adı',
    menuIcon: 'Menü simgesi',
    messagePush: 'Mesaj itmesi',
    messagePushDeleteAsk: 'Bu itmeyi sildiğinizden emin misiniz?',
    messagePushDownloadTemplate: 'Lütfen önce şablonu indirin ve şablon dosyasını doldurduktan sonra dosyayı yükleyin. Dosya boyutu 2M ile sınırlıdır.  Gönderme başarısız olursa, lütfen uygun içeriği azaltın',
    messageWithdrawAsk: 'Bu itmeyi geri almak ister misiniz?',
    middle: 'orta',
    min: 'Min.',
    minAgo: '%s dk önce',
    minimum: 'Min.',
    minimumValue: 'Minimum',
    modelDetail: 'Model ayrıntıları',
    modifyFail: 'Değişiklik başarısız oldu',
    modifyPassword: 'Şifreyi değiştir',
    modifySuccess: 'Düzenleme Başarılı',
    monday: 'Pazartesi',
    more4pic1video: 'Maksimum 4 resim / 1 video',
    morning: 'Sabah',
    motorcycle: 'iki tekerlekli',
    moveDown: 'Aşağı hareket et',
    moveLongPressMap: {},
    moveMapSelectPoint: {},
    moveTo: ' taşın',
    moveToBottom: 'En alta taşın',
    moveToTop: 'En üste taşın',
    moveToTopStatus: 'Üste kaydır',
    moveTop: 'En üstte',
    moveUp: 'Yukarı hareket et',
    multimedia: 'Multimedya',
    mustInteger: {},
    mute1Day: '1 gün boyunca sessiz',
    mute2Days: '2 gün boyunca sessiz',
    mute30Days: '30 gün boyunca sessiz',
    mute3Days: '3 gün boyunca sessiz',
    mute7Days: '7 gün boyunca sessiz',
    muting: 'Sessiz',
    nameOfImporter: 'İthalatçı adı',
    navigation: 'Harita navigasyonu',
    nearLoginTime: 'Son giriş zamanı',
    needPopup: 'Açılır pencereye ihtiyacınız var',
    negativeNum: 'Kötü inceleme',
    networkException: 'Ağ istisnası',
    newAddFail: 'Ekleme başarısız oldu',
    newAddSuccess: 'başarıyla eklendi',
    newBanner: 'Yeni Afiş',
    newCancellationAgreement: 'Yeni iptal sözleşmesi',
    newFunctionIntro: {},
    newMenuFunction: 'Yeni menü işlevi',
    newModelSeries: 'Yeni model serisi',
    newPassword: 'Yeni Şifre',
    newPasswordNotEqual: 'İki kez girilen yeni şifre tutarsız, lütfen tekrar girin',
    newQuestionType: {},
    newStoreNumber: 'Yeni mağaza sayısı',
    newTopic: 'Yeni konu',
    newUnbindingCommitment: {},
    nextStep: 'Sonraki',
    nickName: 'Takma ad',
    no: 'Numara',
    noContent: 'İlgili içerik yok',
    noContent2: 'Anahtar kelimeleri değiştirmeyi öner veya',
    noData: 'Veri yok',
    noFeedbackRecord: 'Şu anda herhangi bir geri bildirim kaydı bulunmamaktadır.',
    noJump: 'Atlama yok',
    noLog: 'Günlük yok',
    noNeedPopup: "Pop-up'lara gerek yok",
    noOkToFeedback: 'Çözülmedi, geri bildirim vermek istiyorum',
    noOwnerScore: 'Sahip olmayanların derecelendirmeleri',
    noPass: 'Başarısız',
    noSendPeople: 'Gönderen Yok',
    noSupportMapDown: {},
    noThisPermission: 'Bu işlem için izin yok',
    noUserSelected: 'Hiçbir kullanıcı seçilmedi, gönderilemiyor',
    nofiledSeviceContent: {},
    nonOwner: 'Sahibi olmayan',
    nonVehicleOwnerCharged: {},
    none: 'Hiç kimse',
    normal: 'Normal',
    notAllowImageAndVideo: 'Görüntü seçerken video seçilemiyor',
    notAllowed: 'İzin verilmez',
    notBeLessOrEqual: 'Aşağıdakilerden az veya eşit olmayacaktır',
    notDeleted: 'Çıkılmadı',
    notDistributedYet: 'Henüz yayınlanmadı',
    notEnabled: 'Etkin değil',
    notHelpful: {},
    notLessThan: 'Daha az olmamalıdır',
    notRecommended: 'Önerilmez',
    notReleasedYet: 'Henüz yayınlanmadı',
    notStarted: {},
    notTop: 'En üste değil',
    notice: 'Fark etme',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. We are committed to enhancing service quality and implementing innovative improvements, and we have made business adjustments due to this commitment. As of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In its place, we have launched the brand-new CFMOTO RIDESYNC App. We hope you continue to enjoy our services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Sürüm numaralarının tümü 0 olamaz',
    offline: 'Çevrimdışı',
    offlineAlready: 'Çevrimdışı',
    offlineTime: 'Çevrimdışı zaman',
    offlineTimeMustBeGreaterThan: 'Çevrimdışı zaman ≥ olmalıdır',
    ok: 'tamam',
    oldPassword: 'eski şifre',
    onLineAlready: {},
    oneMonths: 'Bir ay',
    oneYear: 'Bir yıl',
    online: 'Çevrimiçi',
    onlyFourWheel: 'Sadece dört tekerlekli',
    onlyTwoWheel: 'Sadece iki tekerlekli',
    openEveryCount: {},
    openEveryDay: {},
    openProductType: {},
    operationRecord: 'Çalışma kaydı',
    operationTime: 'Çalışma süresi',
    operations: 'İşlemler',
    operator: 'Şebeke',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'İsteğe bağlı güncelleme',
    orderList: {},
    orderMange: {},
    orderNum: {},
    otaUpgradeVehicle: 'OTA yükseltme aracı',
    otaUpgradeVehicleDesc: 'Aracın ana bileşenleri, araç performansını sürekli olarak yinelemek için uzaktan yükseltilebilir.',
    other: 'Diğer',
    over: 'üzerinde',
    owner: 'Araba al',
    ownerIdHomepageImage: 'Kimlik kartı, sürücü belgesi veya pasaportun kişisel tanıtım bilgilerini içeren ana sayfası.',
    parameterConfiguration: 'Parametre konfigürasyonu',
    partialImportFailed: 'Kısmi içe aktarma başarısız',
    pass: 'Geç',
    passValidateDeleteAccount: 'Başarılı kimlik doğrulaması! Hesabının silinmesine başvurmak için alttaki İsteği Gönder düğmesini tıklayın',
    password: 'şifre',
    passwordRuleText: '8-20 karakter, büyük ve küçük İngilizce harfler, sayılar, özel karakterler içermelidir',
    passwordRules: 'Şifre kuralları',
    paySetting: {},
    payStrategy: {},
    peleaseEnterProvince: 'Lütfen bir il/eyalet girin',
    pendSend: 'Askıda olması',
    pending: 'Beklemede',
    permanentMuting: 'Kalıcı olarak sessize alındı',
    phoneModel: 'Model',
    phoneNum: 'telefon numarası',
    phoneNumber: 'Telefon numarası',
    phoneOrEmail: 'Telefon numarası/E-posta',
    phoneOrEmailImportTemplate: 'Cep telefonu numarası/e-posta adresi içe aktarma şablonu',
    phoneOrEmailNotRegistered: 'Bu cep telefonu numarası veya e-posta adresi kayıtlı değil',
    phoneOrEmailOrUserId: 'Cep telefonu numarası/e-posta adresi/kullanıcı kimliği',
    picture: 'Resim',
    pl_PL: 'Lehçe',
    pleaseAddImage: 'Lütfen resim dosyalarını ekleyin',
    pleaseAddVideoFile: 'Lütfen video dosyalarını ekleyin',
    pleaseEnter: 'Lütfen girin',
    pleaseEnterAccountInfo: 'Lütfen hesap bilgilerinizi girin',
    pleaseEnterAmount: {},
    pleaseEnterCity: 'Lütfen bir şehir girin',
    pleaseEnterEmail: 'lütfen e-mail adresinizi giriniz',
    pleaseEnterEmailAdress: 'Lütfen e-posta adresini girin',
    pleaseEnterIntro: 'Lütfen tanıtımı girin',
    pleaseEnterLatAndLong: 'Lütfen enlem ve boylamı girin',
    pleaseEnterNewPassword: 'Yeni şifreyi girin',
    pleaseEnterPassword: 'Lütfen şifreyi giriniz',
    pleaseEnterPhone: 'Lütfen telefon numaranızı girin',
    pleaseEnterQuestionDescription: 'Lütfen sorununuzun açıklamasını girin',
    pleaseEnterRealname: 'Lütfen gerçek adınızı girin',
    pleaseEnterRemark: 'Lütfen açıklamalarınızı girin',
    pleaseEnterServePhone: 'Lütfen servis telefon numarasını girin',
    pleaseEnterStoreAddressDetail: 'Lütfen ayrıntılı adresi girin',
    pleaseEnterStoreIntroduce: 'Lütfen mağaza tanıtımını girin',
    pleaseEnterStoreName: 'Lütfen mağaza adını girin',
    pleaseEnterStoreRemarkName: 'Lütfen mağaza açıklama adını girin',
    pleaseEnterTitle: 'Lütfen bir başlık girin',
    pleaseEnterUsername: 'Lütfen kullanıcı adını girin',
    pleaseEnterVercode: "vercode'u girin",
    pleaseEnterVersion: 'Lütfen sürüm numarasını girin',
    pleaseEnterVersionIntroduction: 'Lütfen sürüm tanıtımını girin',
    pleaseEnterVideoDetail: 'Lütfen video ayrıntılarını girin',
    pleaseEnterVin: "Lütfen VIN'i girin",
    pleaseInputWord: 'Lütfen anahtar kelime girin',
    pleaseLoginFirst: 'Lütfen önce giriş yapın',
    pleaseRepeatNewPassword: 'lütfen yeni şifreyi tekrar edin',
    pleaseSelect: 'lütfen seç',
    pleaseSelectBusinessHours: 'Lütfen çalışma saatlerini seçin',
    pleaseSelectCity: 'Lütfen şehir seçin',
    pleaseSelectCountry: 'Lütfen ülke seçin',
    pleaseSelectCurrency: {},
    pleaseSelectMatchingMultimediaContent: 'Lütfen uygun multimedya içeriğini seçin',
    pleaseSelectPayChannel: {},
    pleaseSelectProblemWhere: 'Lütfen sorunun meydana geldiği bir senaryo seçin',
    pleaseSelectProducType: {},
    pleaseSelectProvince: 'Lütfen il/eyalet seçin',
    pleaseSelectQueType: 'Lütfen soru türünü seçiniz',
    pleaseSelectReportReason: 'Lütfen raporlama nedenini seçiniz',
    pleaseSelectStatus: 'Lütfen durum seçiniz',
    pleaseSelectStoreType: 'Lütfen mağaza türünü seçin',
    pleaseSelectTimedSendTime: 'Lütfen gönderim zamanını seçin',
    pleaseSelectUserTheList: 'Lütfen listeden bir kullanıcı seçin',
    pleaseSelectVehicle: 'Lütfen bir araç seçin',
    pleaseSelectVehicleConfig: {},
    pleaseSelectupgradeType: 'Lütfen güncelleme yöntemini seçin',
    pleaseSureType2: 'Lütfen',
    pleaseUpload: 'Lütfen yükleyin',
    pleaseUploadPicVideo: 'Lütfen resim/video yükleyin',
    popUpFrequencyType: 'Açılır pencere formu',
    popUpFrequencyValue: 'Açılır pencere sıklığı',
    popUpFrequencyValueValid: 'Lütfen sıklık günlerini seçin',
    popUpReminder: 'Bir hatırlatıcının açılıp açılmayacağı',
    popupArea: 'açılır kullanıcı aralığı',
    popupCreate: {},
    popupDayOne: 'Belirlenen sayıda gün başına bir kez',
    popupEdit: {},
    popupFrequency: {},
    popupManagement: {},
    popupOne: {},
    popupPosition: {},
    popupStatus: {},
    popupTarget: {},
    popupTime: {},
    popupTitle: {},
    positiveNum: 'İyi eleştiriler',
    postComment: 'Yorum gönder',
    postContent: 'Paylaşım içeriği',
    postId: 'Gönderi Kimliği',
    postList: 'Paylaşım listesi',
    postManagement: 'Paylaşım yönetimi',
    postSearch: 'Paylaşım araması',
    posts: 'Paylaşım',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Gizlilik Politikası İçerik Detayları',
    privacyPolicy: 'Gizlilik Politikası',
    privacyPopupAgree: 'Bir açılır pencere aracılığıyla kullanıcının gizlilik politikasına ilişkin onayını yeniden alın',
    privacyVersion: 'Gizlilik Politikası Sürümü',
    privacyVersionList: 'Gizlilik Politikası Sürüm Listesi',
    problemaDes: 'Sorun Açıklaması',
    processMethod: 'İşleme yöntemi',
    processReason: 'İşleme nedeni',
    processReasonDetails: 'İşleme nedeni ayrıntısı',
    processRecord: 'İşleme kaydı',
    processReport: 'Raporları işle',
    processSolution: 'İşleme çözümü',
    processUser: 'Kullanıcı İşlet',
    processed: 'İşlenmiş',
    productDetails: {},
    productTime: 'üretim süresi',
    prohibitDecimalsAndNegative: {},
    pt_PT: 'Portekizce',
    publishInformation: 'Bilgileri yayınla',
    publishPosts: 'Paylaşımı yayınla',
    pullBefore: 'Yenilemek için aşağı çekin.',
    pulling: 'Yenilemeyi şimdi serbest bırak',
    purchaseAndInstall: 'Satın al ve yükle',
    pushConfiguration: 'İtme yapılandırması',
    pushContent: 'İçeriği itin',
    pushList: 'İtme listesi',
    pushMode: 'İtme modu',
    pushNow: 'Şimdi it',
    pushQuery: 'İtme sorgusu',
    pushRecord: 'İtme kaydı',
    pushScope: 'İtme kapsamı',
    pushTime: 'İtme süresi',
    pushTimeDifferenceAsk: "Seçtiğiniz gönderim zamanı, bazı kullanıcıların zaman farklılıklarından dolayı bu push'u alamamasına neden olabilir. Kaydetmek istediğinizden emin misiniz?",
    pushTitle: 'İtme başlığı',
    pushed: 'itti',
    pushing: 'İtiliyor',
    query: 'Aramak',
    question: {},
    questionInquiry: {},
    questionType: 'Soru Tipi',
    questionTypeList: {},
    questionTypeTemplate: {},
    quickRelease: 'Hızlı yayınla',
    ranking: 'Sıralama',
    ratingWarn1: 'Araç sahibi kullanıcılar için yönetim arka planında ülkeye/bölgeye karşılık gelen akıllı servis kontrolü açılmamış veya açıldıktan sonra akıllı servis servisinin süresi dolmamış. Araç çevrimiçi ve',
    ratingWarn2: "veya daha fazla tam sürüş kaydı var (her sürüşün başlangıcı ve bitişi rapor edilen olaydır), kullanıcı My Cycling'den çıkıp ana sayfaya döndüğünde bir açılır pencere görünecektir.",
    reUpgrade: 'yeniden dene',
    readAgree: 'Okuyun ve kabul edin',
    readAndAgree: 'Lütfen okuyun ve kabul edin',
    readAndAgreeTo: 'okudum ve kabul ediyorum',
    readDeleteStep: 'sileceğimiz veya saklayacağımız veri türlerini ve ek saklama sürelerini anlayın',
    realname: 'Gerçek ad',
    reasonForReport: 'Sebep',
    receiveCarReminderMessage: 'Araç mesajı uyarıları alın',
    rechargeAmount: {},
    rechargeChannel: {},
    rechargeStatus: {},
    rechargeTime: {},
    recharged: {},
    recipients: 'Alıcı',
    recipientsNum: 'Alıcı kapsamı',
    recommended: 'Önerilen',
    recommendedStatus: 'Önerilen durum',
    redirectUrl: {},
    refreshInterval: 'Yenileme aralığı',
    refreshSend: 'Yeniden gönder',
    refundFailed: {},
    refunded: {},
    refunding: {},
    refused: 'Reddedildi',
    registerDate: 'Kayıt zamanı',
    rejected: 'Reddedildi',
    releaseContent: 'İçerik yayınla',
    releaseMute: 'Sessizi serbest bırakın',
    releaseTime: 'Yayın zamanı:',
    released: 'Yayınlandı',
    releasedBy: ' tarafından yayınlandı',
    remark: 'Notlar',
    rememberPassword: 'Şifreyi hatırla',
    reminder: 'Hatırlatıcı',
    remove: 'Kaldır',
    removeOnlinUpgrade: 'Uzaktan çevrimiçi yükseltme aracı',
    repeatNewPassword: 'Yeni şifreyi tekrarlayın',
    replaceTBOX: "TBOX'u değiştirin",
    replied: 'cevap verdi',
    reply: 'Yanıtla',
    report: 'Rapor et',
    reportList: 'Rapor listesi',
    reportManagement: 'Rapor yönetimi',
    reportReason: 'Raporlama nedeni',
    reportReasonDetails: 'Raporlama nedeni ayrıntısı',
    reportReasonPlaceholder: 'Ne raporlamak istediğinizi yazın, 0-1500 kelime',
    reportSearch: 'Rapor arama',
    reportSuccessful: 'Başarılı bir şekilde rapor edin, mümkün olan en kısa sürede ilgileneceğiz',
    reportTime: 'Raporlama zamanı',
    reportType: 'Rapor türü',
    reportedContent: 'Raporlanan içerik',
    reportedUser: 'Raporlanan kullanıcı',
    reportedUserId: 'Raporlanan kullanıcı ID',
    requestTimedOut: 'İstek zaman aşımına uğradı',
    reset: 'Sıfırla',
    return: 'Geri dön',
    review: 'Gözden geçirmek',
    reviewApproved: 'İnceleme geçti',
    richText: {},
    ro_RO: 'Romen',
    roleDescription: 'Rol Tanımı',
    roleName: 'Rol ismi',
    rolePermission: 'rol izni',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'Rusça',
    safeRemind: 'Hesabınızın güvenliğini korumak için lütfen hesap şifreleri vb. gibi hassas kişisel bilgileri buraya göndermeyin.',
    satelliteMap: 'Uydu haritası',
    saturday: 'Cumartesi',
    save: 'Kayıt etmek',
    saveAndPreview: 'Kaydet ve önizle',
    saveFail: 'Kaydedilemedi',
    savePicture: 'Resmi Kaydet',
    saveSettings: 'Ayarları kaydet',
    saveSuccess: 'Başarıyla kaydedildi',
    saveVideo: 'Videoyu kaydet',
    scanQrcodePreview: 'Önizlemek için aşağıdaki QR kodunu cep telefonunuzla tarayın',
    screenNavigationGuidance: 'Kurulum talimatları',
    sdkStatement: 'SDK beyanı',
    search: 'Aramak',
    searchRecords: 'Tarihsel arama',
    secondaryMenu: 'İkinci menü',
    securityMessage: 'Yukarıdaki bilgiler yalnızca kimlik doğrulama için kullanılır, CFMOTO bilgilerinizi korur.',
    select: 'Seç',
    selectAll: 'Hepsini seç',
    selectAuthentication: 'Kimlik doğrulamayı seç',
    selectChannelType: 'Lütfen bir geri bildirim kanalı seçin',
    selectCountry: 'Ülke seçin',
    selectData: 'Lütfen silmek istediğiniz verileri seçin ve veri silme isteğinizi göndermek için alttaki Gönder düğmesini tıklayın.',
    selectDate: 'Tarih seç',
    selectEnableStatus: {},
    selectFeedBackState: 'Geri bildirim işleme durumunu seçin',
    selectFeedbackType: 'Lütfen bir geri bildirim türü seçin',
    selectJumpTarget: {},
    selectLanguage: 'Lütfen dil seçin',
    selectOneCarType: 'En az bir model seçin',
    selectPoint: {},
    selectPopupFrequency: {},
    selectPopupPosition: {},
    selectPopupTarget: {},
    selectPopupTime: {},
    selectRejectReason: 'Lütfen reddedilme nedeni seçin',
    selectTheLanguage: 'Dili seçin',
    selectTime: 'zamanı seçme',
    selectUser: 'Kullanıcıları seçin',
    selectVehicle: 'Araç Seçiniz',
    selectionOfImporter: 'İthalatçı seçimi',
    sendNumberDescription: 'Etkili hedef cihazlar arasında, Aurora sunucusu aslında görev gönderilecek cihaz sayısını başarıyla oluşturur',
    sendNumberVolume: 'Gönderme sayısı',
    sendType: 'Gönderme modu',
    sendUserNum: 'Gönderme sayısı',
    sending: 'Gönderirken',
    serial: 'Hayır.',
    seriesBackground: {},
    seriesDesc: {},
    seriesIntroduction: 'Seri İşletme',
    seriesName: {},
    seriesShowcase: 'Seri Gösterim Bölümü',
    seriesUplodImgRule: {},
    seriousAlarm: 'Ciddi alarm',
    serviceIntroduction: 'Hizmet tanıtımı',
    serviceText: 'Hizmet',
    settingSuccess: 'başarıyla ayarla',
    shareNumber: 'Paylaşım sayısı',
    sheet: 'Zhang',
    show: 'Görünüm',
    showPicturesOfVideos: 'Fotoğrafları/videoları göster',
    showroomModel: 'Gösterim modelleri',
    showroomModelList: 'Showroom model listesi',
    showroomModelQuery: 'Showroom model sorgulama',
    showroomUploadRules: "Resim formatı gereksinimi jpg/jpeg/png, resim oranı 9:19,5, boyut 5 MB'ı ve video boyutu 50 MB'ı geçmemelidir.",
    signOut: 'Otomatik sonlandırma',
    singapore: 'Singapur',
    sixMonths: 'Altı ay',
    slideToRight: 'sağa kaydır',
    smartServices: 'Akıllı Hizmetler',
    someUser: 'Bazı kullanıcılar',
    sort: 'Sırala',
    source: 'Kaynak',
    sr_YU: 'Sırpça',
    startChecking: 'Kontrol başla',
    startTime: 'Başlama zamanı',
    statisticalTime: 'İstatistiksel zaman',
    status: 'Durum',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: {},
    store: {},
    storeAddressCountryTip: 'Not:  Bu mağaza adresi, kullanıcıların sizi bulması için tek dayanaktır.  Adresin doğru olduğundan emin olmak için lütfen dikkatlice doldurun',
    storeAddressDetail: 'Mağaza adresi',
    storeAddressDetailTip: 'Örnek: ayrıntılı adres:  NO.116, Wuzhou Yolu, Yuhang Ekonomik Kalkınma Bölgesi, Hangzhou',
    storeAddressPosition: 'Enlem ve boylam',
    storeAddressPositionTip:
      'Boylam: Boylamın tam sayı kısmı -180 ile 180 arasında bir tam sayıdır ve ondalık kısım 15 basamağı geçmeyen bir ondalıktır.\nEnlem: Enlemin tam sayı kısmı -90 ila 90 arasında bir tam sayıdır ve ondalık kısım 15 ondalık basamaktan fazla değildir.',
    storeBusinessType: 'Mağaza tipi',
    storeImage: 'Mağaza resmi',
    storeImportTemplateText: 'Lütfen şablonu indirin, bayi mağaza bilgilerini şablon dosyasına doldurun ve ardından dosyayı yükleyin; dosya boyutu 1 MB ile sınırlıdır; gönderim başarısız olursa, içeriği azaltın veya toplu olarak yükleyin',
    storeIntroduce: 'Mağaza tanıtımı',
    storeList: 'Mağaza listesi',
    storeMange: 'Mağaza Yönetimi',
    storeName: 'Mağaza adı',
    storeNameTip: 'Not:  Lütfen mağaza adını doldurmak için sistem tarafından desteklenen bir dil seçin',
    storeQueryUserStatistics: 'Mağazadaki sorgu kullanıcısı istatistikleri',
    storeRemarkName: 'Mağaza açıklama adı',
    storeRemarkNameTip: 'Not:  Sistem tarafından desteklenen dil ihtiyaçlarınızı karşılamıyorsa, buraya istediğiniz dilde mağaza açıklama adını girebilirsiniz.',
    storeSearch: 'Mağaza sorgusu',
    storeServicePhone: 'Hizmet telefon numarası',
    storeServicePhoneTip: 'Not:  Bu numara müşteri telefon görüşmesi için kullanılır, lütfen telefon numarasının doğru olduğundan emin olun.',
    storeServiceTime: 'Açılış zamanı',
    storeStatistics: 'Mağaza istatistikleri',
    storeUploadImageRequire: "jpg/jpeg/png için resim formatı gereksinimleri, tek bir resmin boyutunun 5 MB'ı geçmemesi önerilir, tek bir içe aktarma 9'a kadar olabilir, birden fazla kez içe aktarılabilir, toplam sayı 9'dan fazla olamaz",
    storefront: 'Mağaza',
    submissionFailed: 'Gönderme başarısız oldu, lütfen tekrar deneyin.',
    submit: 'Göndermek',
    submitAccountDeleteApply: 'Hesap silme isteğini gönder',
    submitDataDeleteApply: 'Veri silme isteğini gönder',
    submitFeedback: 'Geri bildirim gönder',
    submitted: 'Gönderildi',
    successful: 'Başarılı',
    sunday: 'Pazar',
    supportMapDown: {},
    supportedChannel: {},
    sureAgree: 'Katılıyor musunuz, katılmıyor musunuz?',
    sureBackApply: 'Hesap silme başvurusunun geri çekilmesini onaylayın',
    sureDelete: 'Bir kere silindikten sonra geri getirilemez. Silmek istediğinizden emin misiniz',
    sureDeleteData: 'Seçilen verileri sildiğinizden emin misiniz?  Onaylandıktan sonra, veriler hemen silinir ve kurtarılamaz',
    sureDeleteSeries: {},
    sureDeleteSetting: {},
    sureDeleteStoreInfo: 'Bu mağaza bilgilerinin silinmesini onaylıyor musunuz? Silme işleminden sonra bilgiler kurtarılamaz',
    sureReject: 'Reddedeceğinizden emin misiniz?',
    sureSuspend: 'Gönderme işlemi sonlandırıldıktan sonra duracaktır. Sonlandırmak istediğinizden emin misiniz',
    suspend: 'Sonlandır',
    sv_SE: 'İsveççe',
    switchLanguage: 'Dili değiştir',
    system: 'Sistem',
    systemBusy: 'Sistem meşgul, lütfen daha sonra tekrar deneyin',
    systemVersion: 'sistem sürümü',
    tboxIntro: 'T-Box, araçların akıllı ağ bağlantısı işlevini gerçekleştiren temel cihazdır',
    teamConfigTip: {},
    threeMonths: 'Üç ay',
    thursday: 'Perşembe',
    time: 'Zaman',
    timeSend: 'Zamanlanmış gönderme',
    timedOffline: 'Zamanlanmış çevrim dışı',
    timedPush: 'Belirli bir zamanda it',
    timedRelease: 'Zamanlanmış yayınlanma',
    timedSendTime: 'Gönderme zamanı',
    tips: 'İpuçları',
    title: 'Başlık',
    to: 'ila',
    toBeReleased: 'Yayınlanacak',
    topMenu: 'Üst menü',
    topicContent: 'Konu içeriği',
    topicList: 'Konu listesi',
    topicManagement: 'Konu yönetimi',
    topicSearch: 'Konu arama',
    topicTitle: 'Konu başlığı',
    totalAndlLayoutOfStores: 'Toplam mağaza sayısı ve yerleşimi',
    totalClicks: {},
    totalNumber: 'Toplam zaman',
    tr_TR: 'Türkçe',
    triggerNum: 'Tetikleyici sayısı',
    tuesday: 'Salı',
    turnOn: 'Açık',
    twoCarAndFourCarOfNumber: 'İki tekerlekli ve dört tekerlekli araç olan kullanıcı sayısı',
    twoCarOfNumber: 'İki tekerlekli araç olan kullanıcı sayısı',
    twoWheelConfig: {},
    twoWheeler: 'İki tekerlekli',
    twoWheelerAndFourWheeler: 'İki tekerlekli ve dört tekerlekli',
    twoWheelerMostClicks: 'En çok tıklanan iki tekerlekli araç modelleri',
    twoWheelowner: {},
    typeMessage: 'geri bildirim türü',
    types: 'Tip',
    unbind: 'Bağlı değil',
    unbindingCommitment: {},
    unbindingLabelRealName: 'Tam adınız',
    unbound: 'Bağlanmamış',
    understandRealtimeConditions: 'Araç titreşimlerini ve elektronik çit giriş ve çıkış araç hatırlatma mesajlarını alın ve araç durumunu gerçek zamanlı olarak anlayın',
    uninstallTboxDesc: 'T-Box takılı olmayan araçlar için bağlama sonrasında şasi numarası, motor numarası ve elektronik kılavuz gibi temel araç bilgilerini görüntüleyebilirsiniz.',
    unitCurrencyPer: {},
    unitMonth: 'Ay',
    unlimited: 'Sınırsız',
    unpaid: {},
    unprocessed: 'Yapılmadı',
    unresolved: 'Hala çözemiyor musun? Tıklamak',
    unspecified: 'Gizlilik',
    upToTopics: 'En fazla %s konu eklenebilir',
    updateAuthenticationTime: 'Kimlik doğrulama zamanı gücelle',
    updateBy: 'Güncelleyici',
    updateSuccess: {},
    updateTime: 'Güncelleme zamanı',
    updating: 'güncelleme',
    upgradeAgainDescription: "Yükseltme görevi yeniden itildi. Yükseltmek üzere tft ekran ağına bağlanmak için lütfen mevcut sayfanın üst kısmındaki `Kılavuz'u takip edin.",
    upgradeAssistant: 'Yardım',
    upgradeDescription: "Yeni sürüm bulunduğunda, yükseltme yapmak üzere tft ekran ağına bağlanmak için lütfen mevcut sayfanın üst kısmındaki `Kılavuz'u takip edin.",
    upgradeSuccessful: 'Yükseltme Başarılı',
    upgradeType: 'Güncelleme yöntemi',
    upload: 'Yüklemek',
    uploadDisplayPicture: {},
    uploadFail: 'Yükleme başarısız oldu',
    uploadFailed: 'Yükleme başarısız oldu, lütfen başka bir ağ deneyin',
    uploadFailedOfTry: 'Yükleme başarısız, lütfen tekrar deneyin',
    uploadFileMore1M: 'Yükleme dosyası boyutu 1 milyonu geçmiyor',
    uploadFiles: 'Dosya yükle',
    uploadImageRules1To1: "Görüntü format ı jpg/jpeg/png olmak için gerekli, 1:1 görüntü oranı ve 5 MB'nin en büyük boyutlu",
    uploadLog: 'Günlük yükle',
    uploadPicture: 'Resim yükle',
    uploadQuantityExceed: 'Yükleme sayısı sınırı aşıyor',
    uploadSuccessful: 'Yükleme başarılı',
    uploadTime: 'Yükleme süresi',
    uploadTip556_740: {},
    uploadVideoRules: "Video dosyalarının yalnızca tek bir şekilde yüklenmesi desteklenir. Tek bir videonun boyutunun 50 MB'ı geçmemesi tavsiye edilir.",
    uploadVideoRules4To3: "Video format ını destekle, 4:3'in önerilen ilişkisi, 50MB'den fazla boyutlu",
    urlLink: 'URL bağlantısı',
    user: 'Kullanıcı',
    userEmail: 'E-posta',
    userGender: 'kullanıcı cinsiyeti',
    userId: 'Kullanıcı Kimliği',
    userIdTemplate: 'Kullanıcı Kimliği İçe Aktarma Şablonu',
    userIdentity: 'Kullanıcı kimliği',
    userLocalTime: 'Kullanıcı yerel saati',
    userLogin: 'Giriş Yap',
    userMobilePhone: 'Telefon numarası',
    userModel: 'Kullanıcı modeli',
    userName: 'Kullanıcı adı',
    userName1: {},
    userNickname: 'Kullanıcının Takma Adı',
    userNum: 'Kullanıcı numarası',
    userPhone: 'cep telefonu numarası',
    userRealName: 'Kullanıcı gerçek adı',
    userReply: 'Bekleyen kullanıcı yanıtı',
    userStatus: 'Kullanıcı durumu',
    userType: 'Kullanıcı tipi',
    userUnbind: 'Kullanıcının bağlantısını kaldır',
    users: 'kullanıcılar',
    vacationTime: 'Tatil süresi',
    validNumberVolume: 'Geçerli hedeflerin sayısı',
    validNumerDescription: 'Etkinlik taramasından sonra itme görevi tarafından seçilen hedef kitle ve hedef cihaz sayısı',
    validateEmail: 'E-posta adresi formatı yanlış, lütfen kontrol edin.',
    validateImageRadio: 'Resim dosyası biçimi gereksinimleri:  %s, resim ölçeği:  %s, en fazla %s',
    validateImageSize: 'Resim dosyası biçimi gereksinimleri:  %s, önerilen resim boyutu:  %s, en fazla %s',
    validatePhone: 'Telefon numarası format hatası, lütfen kontrol edin',
    validateVideo: 'Video dosyası biçimi gereksinimleri:  %s, en fazla %s',
    validateVin: 'Yanlış VIN, lütfen kontrol edin.',
    vehicleAlarmDetails: 'Araç Alarm Detayları',
    vehicleBindDuration: 'Araç bağlama süresi',
    vehicleBrochure: 'Araç broşürü',
    vehicleColor: 'Araç rengi',
    vehicleDetails: 'Araç detayları',
    vehicleDrivingLicense: 'Araç Kayıt Belgesi.',
    vehicleFaultDetails: 'Araç arıza detayları',
    vehicleGallery: 'Araç Galerisi',
    vehicleGalleryEntranceConfiguration: 'APP motosiklet showroom sayfası ve araç galerisi işlevi giriş resimlerinin tümü aşağıdaki konfigürasyondan alınmıştır. Lütfen üç resmin konfigürasyonda tamamlandığından emin olun.',
    vehicleGalleryEntranceSettings: 'Araç galerisine giriş ayarları',
    vehicleGalleryUploadRules: "Resim formatı gereksinimi jpg/jpeg/png'dir. Tek bir görselin boyutunun 5 MB'ı geçmemesi tavsiye edilir. Bir seferde en fazla 10 resim içe aktarılabilir. Çoklu içe aktarmaya izin verilir.",
    vehicleIdHomepageImage: "Araç Kayıt Belgesi'nin ana sayfası, sahibin adı ve VIN bilgisiyle birlikte.",
    vehicleModel: 'Araç modeli',
    vehicleModelAlbum: 'Model albümü',
    vehicleModelCategorySort: 'Araç kategorisine göre sırala',
    vehicleModelDescription: 'Model Açıklaması',
    vehicleModelList: 'Model listesi',
    vehicleModelManagement: 'Araç modeli yönetimi',
    vehicleModelName: 'Model adı',
    vehicleModelQuery: 'Araç modeli sorgusu',
    vehicleModelSeries: 'Modeli serisi',
    vehicleModelSorting: 'Model sıralama',
    vehicleModelType: 'Model türü',
    vehicleName: 'Araç Adı',
    vehicleNetworkEquipment: 'Araç ağ cihazı',
    vehicleOutboundCountry: 'Dışarıdaki araba ülkesi',
    vehicleRemark: 'araç açıklamaları',
    vehicleShareInstruction: 'Vehicle sharing instructions',
    vehicleShareInstructionAdd: 'Yeni araç paylaşma talimatları',
    vehicleShareInstructionEdit: 'Araç paylaşım talimatlarını düzenle',
    vehicleType: 'Motor No.',
    vehicleTypeSplicing: 'Geri bildirim modeli',
    vehicleUnbindingInstructions: 'Aracın serbest bırakılması için başvuru talimatları',
    versionCode: 'Versiyon numarası',
    versionIntroduction: 'Sürüm Tanıtımı',
    versionManage: 'Sürüm yönetimi',
    versionManageList: 'Sürüm yönetimi listesi',
    versionMangeTip:
      "Not: Uygulama pazarında şu anda yayınlanan sürüm numarasından daha büyük bir sürüm oluşturulmasına izin verilmez! İşletme ve bakım personelinin en son sürümün Google Play veya App Store'da yayınlanmasını beklemesi ve ardından en son sürüm numarasına karşılık gelen sürüm kayıtlarını oluşturması gerekir. Önceden kayıt oluşturmaya izin verilmez.",
    versionPattern: 'Sürüm numarası yalnızca 0 ila 999 arasında bir tam sayı olarak girilebilir.',
    versionRequired: 'Sürüm numarası boş olamaz',
    video: 'Video',
    videoContent: 'Video içeriği',
    videoCover: 'Video kapağı',
    videoDetail: 'Video ayrıntıları',
    videoDisplayImages: 'Video ekranı',
    videoFile: 'Video dosyası',
    videoGuide: 'Video önyükleme yapılandırması',
    videoImageValidate: 'Resim dosyası formatı gereksinimleri: png jpg jpeg, resim oranı 16:9, boyut en fazla 5 MB',
    videoList: 'Video listesi',
    videoMaxSizeValidate: "Video boyutu 150 MB'ı aşamaz",
    videoSizeExceed: 'Lütfen %s genişliği ve yüksekliği olan bir video yükleyin',
    viewAllComment: 'Tüm yorumları görüntüle',
    viewCount: 'görüntüleme sayısı',
    viewCurrentLocation: "Herhangi bir zamanda aracın mevcut konumunu görüntülemek için APP 'yi açın",
    viewCurrentLocation2: "Yakın mesafeden araç bulmak için uygun olan herhangi bir zamanda aracın mevcut konumunu görüntülemek için APP'yi açın.",
    viewDetails: 'Ayrıntıları Görüntüle',
    viewFeedBackRecords: 'Geri bildirim kayıtlarını görüntüle',
    viewLocation: "Araç konumunu istediğiniz zaman kontrol etmek için APP'yi açın",
    viewModel: {},
    viewPush: 'İtmeyi Görüntüle',
    viewSeries: {},
    viewVehicleInfomation: 'Günlük sürüş parkurunu, kilometreyi, süreyi, hızı ve aracın diğer bilgilerini görüntülemek için destek',
    views: 'Görüntüleme',
    vin: 'VIN',
    virginia: 'virjinya',
    waitForReview: 'İnceleme bekleniyor',
    waitUploading: 'Yükleniyor, lütfen bekleyin',
    waitingManualReview: 'Manuel inceleme bekleniyor',
    waitingOnline: {},
    waitingPush: 'Beklemek',
    wednesday: 'Çarşamba',
    whatOTA: 'OTA nedir?',
    whyUseNavigation: 'Navigasyon nasıl kullanılır',
    whyUseSetting: 'APP genel ayarları nasıl yapılır?',
    withCountry: 'Ülke/Bölge(IP)',
    withInformation: 'Bilgiler ile',
    withTBOX: {},
    withdrawn: 'Geri alındı',
    withoutCarOfNumber: 'Aracı olmayan kullanıcı sayısı',
    withoutTBOX: {},
    writeAccountToPass: 'Hesap bilgilerini doldurun ve kimlik doğrulamasını tamamlayın',
    year: {},
    yes: 'Evet',
    youHaveFeedbackMessage: 'Etkili bir şekilde takip edilmeyen ** kullanıcı geri bildiriminiz var, lütfen zamanında ilgilenin',
    youthVehicleOwner: {},
    yoyGrowth: 'Yıldan Yıla Artış',
    zh_CN: 'Çince',
  },
};
